module.exports = __webpack_public_path__ + "static/cinammon-ad508b7093f295bc6b61d536e9cdb109.jpg";